import axios from "axios";
import { getToken } from "./api";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const c = axios.create({ baseURL: API, timeout: 20000 });
c.interceptors.request.use((cfg) => { const t = getToken(); if (t) cfg.headers.Authorization = `Bearer ${t}`; return cfg; });

export async function getPricingConfig() { return (await c.get("/pricing/config")).data; }
export async function getQuote(sel) { return (await c.post("/pricing/quote", sel)).data; }
export async function getCart() { return (await c.get("/cart")).data; }
export async function addToCart(payload) { return (await c.post("/cart", payload)).data; }
export async function removeCartItem(id) { return (await c.delete(`/cart/${id}`)).data; }
